import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AuthService } from '../core/auth.service';
import { BaseService } from '../shared/base.service';
import { BaseComponent } from '../shared/base.component';
import { AppService } from '../app.service';
import { ServiceProviderSettingService } from './service-provider-setting.service';

@Component({
    selector: 'service-provider-setting-component',
    templateUrl: './service-provider-setting.component.html',
    providers: [BaseService]
})

export class ServiceProviderSettingComponent extends BaseComponent implements OnInit {

    tabName = '';
    componentUrl = '';
    deletingData: any;
    itemLanguage: string;
    languages = [];
    deleteModal;

    constructor(public authService: AuthService,
                public router: Router,
                public baseService: BaseService,
                public appService: AppService,
                public fb: FormBuilder,
                public serviceProviderService: ServiceProviderSettingService 
                ) {
        super(authService, router, baseService, appService);
    }

    ngOnInit() {
        this.sortedColumn = 'id';
        this.itemsPerPage = 20;
        this.itemLanguage = 'de_CH';
        this.languages = JSON.parse(localStorage.getItem('languages'));
        super.ngOnInit();
    }

    initAction() {
        switch (this.params['action']) {
            case 'create': {
                this.openFormModal({action: 'create', component: this.componentUrl, title: 'Add ' + this.tabName, url: this.url});
                break;
            }
            case 'update': {
                this.openFormModal({action: 'update', component: this.componentUrl, id: this.params['id'], title: 'Edit ' + this.tabName, url: this.url});
                break;
            }
            case 'read': {
                this.openFormModal({
                    action: 'read', id: this.params['id'], title: this.tabName + ' Details',
                    content: this.params['content'], description: this.params['description'], url: this.url
                });
                break;
            }
            case 'delete' : {
                this.params['url'] = this.url;
                this.openConfirmModal(this.params);
                break;
            }
            default: {
                this.getItems();
                break;
            }
        }
    }

    openFormModal(params: Object) {
        this.initForm(params);
        this.serviceProviderService.read(this.url, params['id'])
            .subscribe(response => {
                let data = response['data'];
                let form = {};
                let disabled = params['action'] === 'read' ? true : false;

                for (let column in data) {
                    if (data.hasOwnProperty(column)) {
                        form[column] = {value: data[column], disabled: disabled};
                    }
                }

                this.initFormDataToModal(form, response, params)
                this.showModal();
            });
    }

    initFormDataToModal(form, response = null, params = {}){
       // This function will be override by children component
       return form;
    }

    delete(data) {
        this.deletingData = data;
        this.deleteModal.show();
    }

    submitDelete() {
        this.isLoading = true;
        this.serviceProviderService.delete(this.url, this.deletingData).subscribe(res => {
            this.isLoading = false;
            if (res['success']) {
                this.deleteModal.hide();
                this.modal.hide();
                const message = res['message'];
                this.isUpdated = true;
                this.getItems();

                if (message) {
                    const alert = this.dialog.openAlert({icon: 'far fa-trash-alt'});
                    alert.showAlert(message);
                }
            } else {
                const message = res['message'];
                if (message) {
                    const alert = this.dialog.openAlert({icon: 'fas fa-exclamation-triangle'});
                    alert.showAlert(message);
                }
            }
        });
    }

    initForm(params: Object) {
        this.formSubmitted = false;
        super.initForm(params, false);
    }

    setData(data: any): void {
        this.items = data.items;
        this.totalItems = data.total || data.items.length;
        this.paginationHidden = this.items.length === 0;
        this.isLoading = false;
    }

    hideModal() {
        this.modal.hide();
    }

    submitSearch() {
        this.searchItems();
    }

    submitChangeLanguage(value) {
        this.itemLanguage = value;
    }
}
